@include section-styles(0px, 0px);

@include container('.section-inner');

:host(:focus) {
  outline: none !important;
}

section {
  overflow-x: hidden;

  .visualHidden {
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(0 0 99.9% 99.9%);
    overflow: hidden;
    height: 1px;
    width: 1px;
    padding: 0;
    border: 0;
  }

  .headline-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 1170px;
    margin: 0 auto;

    .headline {
      max-width: 570px;
      @include h2;
      white-space: normal;
      word-wrap: break-word;
    }

    .subheadline {
      @include text-bold;
      @include p;
      margin-bottom: 14px;
      line-height: 1.22;
      letter-spacing: .12em;
    }
  }

  .tiles {
    &.tiles-oversize {
      margin: 0 calc((100vw - 100% - 40px) / -2);

      .tiles-inner {
        margin: 0 auto;
      }
    }
  }

  .cards {
    list-style: none outside none;
    display: flex;
    gap: 20px;
    padding-left: 0;
    -webkit-perspective: 10000px;
    perspective: 10000px;
    transition: transform .5s ease-out;

    li {
      list-style: none;
      flex-shrink: 0;

      .card {
        position: relative;
        width: 430px;
        height: 100%;
        border-radius: 10px;
        background-color: var(--color-very-light-grey);
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }

      .text {
        max-width: inherit;
        padding: 35px;
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 0;

        .category {
          margin-bottom: 9px;
          font-size: var(--font-size-xs);
          line-height: 1.57;
        }

        .headline {
          @include text-bold;
          font-size: 24px;
          line-height: 1.33;
        }

        p {
          margin: 13px 0;
          @include text-main;
          font-size: var(--font-size-main-text);
        }

        &.text-top {
          p {
            margin-bottom: 0;
          }
        }

        &.text-bottom {
          p {
            margin-top: 0;
          }
        }

        &.text-center {
          position: absolute;
          top: 0;
        }

        img {
          width: 100%;
        }
      }

      @include card-button;

      .card-button-wrapper {
        bottom: 16px;
        right: 16px;
      }

      .card-overlay-content {
        z-index: 1;
        background-color: var(--color-darker-grey);
        color: var(--color-very-light-grey);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        flex: 1;
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 35px;
        top: 0;
        left: 0;
        opacity: 0;
        visibility: hidden;
        transition: opacity .66s cubic-bezier(0.66,0,0.01,1) .2s, visibility 0s linear 1.32s;

        &.is-overflow {
          overflow-y: scroll;
        }

        p {
          margin: 0 0 10px 0;
          @include text-main;
          font-size: var(--font-size-main-text);
        }

        li {
          list-style: initial;
          @include text-main;
          font-size: var(--font-size-main-text);
        }

        a {
          color: var(--color-red);
        }
      }

      &.card-overlay-open {
        .card-overlay-content {
          opacity: 1;
          visibility: visible;
          transition-delay: 0s;
        }

        .card-button {
          transform: rotate(45deg);
          transition-delay: 0s;
        }
      }
    }
  }

  .image-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: relative;

    &.image-center {
      flex-direction: row;
      align-items: stretch;
      height: 100%;

      img {
        object-fit: cover;
      }
    }

    &.image-bottom {
      flex: 1;
      justify-content: end;
    }

    img {
      width: 100%;
      /*
      height: 100%;
      object-fit: cover;
       */
    }
  }

  .btn-wrapper {
    display: flex;
    flex-flow: row wrap;
    column-gap: 10px;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
    z-index: 100;

    &.hidden {
      display: none;
    }

    @include button-prev-next('.button');
  }

  @include media-min-width($breakpoint-m) {
    .intersection-collider {
      display: block;
      height: 1px;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 0;
    }
  }

  /** Mobile **/

  @include media-max-width($breakpoint-m) {
    .wrapper {
      padding-left: 25px;
      .cards li .card {
        max-width: calc(100vw - 60px);

        .text {
          padding: 25px;

          .category {
            font-size: var(--font-size-xxs);
          }

          .headline {
            font-size: var(--font-size-sm);
          }

          p {
            font-size: 13px;
          }
        }
      }
    }

    .tiles {
      &.tiles-oversize {
        margin: unset;

        .tiles-inner {
          margin: unset;
        }
      }
    }
  }
}

@include media-min-width($breakpoint-m) {
  .sticky-wrap {
    position: relative;

    .sticky-inner {
      position: -webkit-sticky;
      position: sticky;
    }
  }
}
